module.exports = __webpack_public_path__ + "img/image_ot-peru-matarani_tanks1_1920px.be880b34.jpg";